import { useEffect, useRef } from "react";
import { useDebouncedValue } from "../../../hooks/useDebouncedValue";

const RECORD_DELAY_MS = 1500;

export function useRecordSettledSearch(
  searchValue: string,
  addEntry: (value: string) => void
): string {
  const settled = useDebouncedValue(searchValue, RECORD_DELAY_MS);
  const addEntryRef = useRef(addEntry);
  addEntryRef.current = addEntry;

  useEffect(() => {
    const trimmed = settled.trim();
    if (trimmed.length === 0) return;
    addEntryRef.current(trimmed);
  }, [settled]);

  return settled;
}
